import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PulseLoader } from "react-spinners";
import {GetSubscriptionById} from "../redux/actions/teams/members/GetSubscriptionDetailsActions"
import { UpdateSubscription } from "../redux/actions/teams/members/UpdateSubscriptionAction";

const EditSubscription = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [planName, setPlanName] = useState("");
  const [amount, setAmount] = useState("");
  const [validity, setValidity] = useState("");
  const [features, setFeatures] = useState("");
  const [status, setStatus] = useState(true);

  const { response: subscriptionDetail, loading, error } = useSelector(
    (state) => state.SubscriptionDetails
  );
  const {
    loading: updateLoading,
    error: updateError,
  } = useSelector((state) => state.updateSubscription);

  // Fetch plan details on mount
  useEffect(() => {
    if (id) {
      dispatch(GetSubscriptionById(id));
    }
  }, [dispatch, id]);

  // Prefill when data is loaded
  useEffect(() => {
    if (subscriptionDetail?.status && subscriptionDetail.data) {
      const d = subscriptionDetail.data;
      setPlanName(d.plan_name);
      setAmount(d.amount);
      setValidity(d.validity);
      setFeatures(d.features);
      setStatus(d.status === 1);
    }
  }, [subscriptionDetail]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      plan_name: planName,
      amount,
      validity,
      features,
      status: status ? 1 : 0,
    };

    dispatch(UpdateSubscription(id, payload))
      .then(() => navigate("/dashboard/subscription-management"))
      .catch((err) => console.error("Failed to update subscription:", err));
  };

  if (loading) return <div className="text-center p-5">Loading...</div>;
  if (error) return <div className="text-center text-danger p-5">{error.data}</div>;

  return (
    <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
      <section className="main-section">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <form
                onSubmit={handleSubmit}
                className="p-4 shadow rounded bg-white"
              >
                <h3 className="text-center mb-4">Edit Subscription</h3>

                {updateLoading && (
                  <div className="text-center mb-3">
                    <PulseLoader size={10} color="#36d7b7" />
                  </div>
                )}
                {updateError && (
                  <div className="alert alert-danger mb-3">
                    {updateError.data || "Failed to update subscription"}
                  </div>
                )}

                <div className="row g-3 mb-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label">Plan Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter plan"
                      value={planName}
                      onChange={(e) => setPlanName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6">
                      <label className="form-label">Amount</label>
                      <div className="input-group">
                        <span className="input-group-text">£</span>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          required
                        />
                      </div>
                    </div>


                  <div className="col-12">
                    <label className="form-label">Validity</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e.g. One month"
                      value={validity}
                      onChange={(e) => setValidity(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label">Features</label>
                    <textarea
                      className="form-control"
                      placeholder="Add your plan features"
                      value={features}
                      onChange={(e) => setFeatures(e.target.value)}
                      rows={3}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label me-2">Status</label>
                  <input
                    type="checkbox"
                    checked={status}
                    onChange={(e) => setStatus(e.target.checked)}
                  />
                </div>

                <div className="text-center">
                  <button type="submit" className="btn btn-success px-4">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditSubscription;
